import { useState } from "react";
import { Plus, Check } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const AddOnRow = ({ addons }) => {
  const { addItem } = useCart();
  const [added, setAdded] = useState({});
  if (!addons || addons.length === 0) return null;

  const add = (a) => {
    addItem({ productId: a.id, quantity: 1 }, { openDrawer: false });
    setAdded((s) => ({ ...s, [a.id]: true }));
    setTimeout(() => setAdded((s) => ({ ...s, [a.id]: false })), 1500);
  };

  return (
    <div data-testid="addon-row" className="mt-10">
      <h3 className="font-serif text-2xl text-cream mb-1">Enhance Your Experience</h3>
      <p className="text-cream/55 text-sm mb-5">Hand-matched add-ons for this product.</p>
      <div className="snap-row flex gap-4 overflow-x-auto pb-3 -mx-1 px-1">
        {addons.map((a) => (
          <div key={a.id} data-testid={`addon-${a.id}`}
            className="shrink-0 w-44 bg-charcoal border border-white/10 hover:border-gold/30 transition-colors">
            <img src={a.images[0]} alt={a.title} className="w-full h-32 object-cover" />
            <div className="p-3">
              <p className="text-sm font-medium text-cream leading-snug line-clamp-2 min-h-[2.5rem]">{a.title}</p>
              <div className="flex items-center justify-end mt-2">
                <button data-testid={`addon-add-${a.id}`} onClick={() => add(a)}
                  className="flex items-center gap-1 bg-gold text-espresso text-xs px-2.5 py-1.5 hover:bg-amber transition-colors">
                  {added[a.id] ? <Check size={13} /> : <Plus size={13} />}
                  {added[a.id] ? "Added" : "Add"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
